import React, { useState, useEffect, useRef } from "react";
import { _getBaseUrl, _makeId, _isFirstRender } from "../utils/helper";
import { Checkbox } from "../forms";
import { values } from "lodash";

const FilterDropDown = ({ placeholder, nodeType, isFilter, ...props }) => {
  const dropdownRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  // if (props.options) {
  //   props.options.sort((a, b) => {
  //     if (a.label === "De HER") return 1;
  //     if (b.label === "De HER") return -1;
  //     return 0;
  //   });
  // }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const dropdownExpandHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const onChangeHandler = (checked, value) => {
    // console.log("meow", props.filter);
    props.onChange(props.filter, value, checked);
  };

  return (
    <fieldset className="w-full filter-dropdown--wrapper relative border-none" ref={dropdownRef}>

      <legend className="sr-only">{placeholder}</legend>
      <button
        className={`filter-list bg-white flex border border-gewDarkGrey py-4 px-4 md:px-8 w-full items-center justify-between cursor-pointer ${props.toggleClass ? props.toggleClass : ""
          }`}
        aria-expanded={isExpanded}
        onClick={() => dropdownExpandHandler()}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            dropdownExpandHandler(); // Trigger dropdown on Enter key press
          }
        }}
        tabIndex={0}
      >
        <span className="text-base">Alle {placeholder}</span>
        <img
          src={`${_getBaseUrl("src/assets/icons/arrow-down.svg", true)}`}
          alt=""
          className={`filter brightness-0 ${isExpanded ? "rotate-180" : ""}`}
        />
      </button>
      {isExpanded && (
        <div
          className={`filter-dropdown--tray bg-white -mt-0 shadow-lg
          ${!isFilter && nodeType === "all" ? "md:block" : "md:absolute"}
          md:z-20 md:top-full md:left-0 p-5
          ${props.trayClass ? props.trayClass : "w-full"}`}
        >
          <div
            className={`pr-4 grid grid-cols-1 gap-2 ${props.trayBodyClass ? props.trayBodyClass : ""}`}
          >
            {props.options !== undefined &&
              props.options.length > 0 &&
              props.options.map((item, index) => {
                {/* console.log('iiiiiitem', item); */ }
                return (
                  <div key={item.value || index}>
                    <Checkbox
                      label={item.label}
                      value={item.value}
                      checked={
                        props.value.indexOf(item.value) >= 0
                      }
                      onChange={onChangeHandler}
                      nodeType={nodeType}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      )}



    </fieldset>
  );
};

export default FilterDropDown;
